export default "__VITE_ASSET__D$7xza0x__"